<template>
    <div class="form-group--border">
        <h5>{{organization.name}}</h5>
        <div>{{organization.nameFull}}</div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">ИНН:</span>
            </div>
            <div class="col-9">
                {{organization.inn}}
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">КПП:</span>
            </div>
            <div class="col-9">
                {{organization.kpp}}
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">ОГРН:</span>
            </div>
            <div class="col-9">
                {{organization.ogrn}}
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">Адрес:</span>
            </div>
            <div class="col-9">
                {{organization.address}}
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">Телефон:</span>
            </div>
            <div class="col-9">
                {{organization.phone}}
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">E-mail:</span>
            </div>
            <div class="col-9">
                {{organization.email}}
            </div>
        </div>
    </div>
</template>

<script>
  import Api from '@/modules/messenger/api/organizations';
  export default {
    name: "OrganizationProfile",
    props: {
      organizationId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        organization: {}
      }
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        Api.find(this.organizationId).then((response) => {
          this.organization = response.data;
        });
      }
    }
  }
</script>

<style scoped>

</style>